import React from 'react';
import { Container } from './CenterMarker.styles';
import useMeasure from 'react-use-measure';
import { ResizeObserver } from '@juggle/resize-observer';
import { defaultMarkerStyle } from './MarkerStyle';

var CenterMarker = _ref => {
  var {
    markerStyle
  } = _ref;
  var [measureRef, viewportBounds] = useMeasure({
    polyfill: ResizeObserver
  });

  var getMarkerStyle = (marker, condensed) => {
    var _marker$mobileScale;

    var scale = condensed ? (_marker$mobileScale = marker.mobileScale) !== null && _marker$mobileScale !== void 0 ? _marker$mobileScale : 1 : 1;
    return {
      image: marker.markerImage,
      width: marker.width * scale,
      height: marker.height * scale,
      anchorX: (marker.anchorX === undefined ? marker.width / 2 : marker.anchorX) * scale,
      anchorY: (marker.anchorY === undefined ? marker.height / 2 : marker.anchorY) * scale
    };
  };

  var {
    image,
    width,
    height,
    anchorX,
    anchorY
  } = getMarkerStyle(markerStyle !== null && markerStyle !== void 0 ? markerStyle : defaultMarkerStyle(), !!(viewportBounds !== null && viewportBounds !== void 0 && viewportBounds.width) && viewportBounds.width < 900);
  var marginLeft = -anchorX * 2 + width;
  var marginTop = -anchorY * 2 + height;
  return /*#__PURE__*/React.createElement(Container, {
    id: "ol-map-center-marker",
    ref: measureRef,
    $width: width,
    $height: height,
    $marginLeft: marginLeft,
    $marginTop: marginTop,
    $marker: image
  });
};

export default CenterMarker;